/* eslint-disable no-underscore-dangle */
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { ICellEditor } from "@ag-grid-community/core";
import { DateSelectorComponent } from "@iventis/components";
import { styled } from "@iventis/styles";
import { IventisCellEditorParams, IventisTableData } from "../types/data-table.types";
import { createInitialState } from "../lib/grid.helpers";

const _DateCellEditor = <TData extends IventisTableData = IventisTableData>(props: IventisCellEditorParams<TData>, ref: React.ForwardedRef<ICellEditor>) => {
    const { node } = props;
    const initialState = createInitialState(props);
    const [value, setValue] = useState<string>(initialState.value);

    useImperativeHandle(ref, () => ({
        getValue() {
            props.api.forEachNode((n) => {
                if (n.data.id === node.data.id && node.id !== n.id) {
                    n.setDataValue(props.column.getColId(), value);
                }
            });
            return value;
        },
        isCancelBeforeStart() {
            return !node.data.canEdit;
        },
        isCancelAfterEnd() {
            return value === props.value;
        },
    }));

    const dateValue = value ? new Date(value) : null;

    return (
        <StyledDateSelectorContainer>
            <DateSelectorComponent value={dateValue} valueChanged={(value) => setValue(value)} />
        </StyledDateSelectorContainer>
    );
};

const StyledDateSelectorContainer = styled.div`
    width: 100%;
    height: 100%;

    .Mui-Datepicker {
        width: 100% !important;
        min-width: 160px;
    }

    .MuiInputBase-root {
        padding: 0px 10px !important;
        border: none;
        border-radius: 0px;
    }

    .MuiInputBase-input {
        padding: 9px !important;
    }
`;

export const DateCellEditor = forwardRef(_DateCellEditor);
